import React from "react";
import {
  Flex, SimpleGrid, Text, Button, Icon,
  useColorModeValue, Skeleton,
} from "@chakra-ui/react";
import { MdSave } from "react-icons/md";
import Card from "components/card/Card.js";
import InputField from "components/fields/InputField";

export default function Information({ formData, onChange, onSave, saving }) {
  const textColor = useColorModeValue("navy.700", "white");
  const subColor  = useColorModeValue("gray.500", "gray.400");
  const loaded    = !!formData;

  const field = (id, label, placeholder, key) => (
    <Skeleton isLoaded={loaded} borderRadius="12px">
      <InputField
        id={id}
        label={label}
        placeholder={placeholder}
        value={formData?.[key] ?? ""}
        onChange={(e) => onChange(key, e.target.value)}
      />
    </Skeleton>
  );

  return (
    <Card>
      <Flex direction="column" mb="24px">
        <Text fontSize={{ base: "md", md: "lg" }} fontWeight="800" color={textColor}>
          Dados Pessoais
        </Text>
        <Text fontSize="sm" color={subColor} mt="2px">
          Atualize suas informações de contato e cargo
        </Text>
      </Flex>

      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing="16px" mb="24px">
        {field("firstName", "Nome",      "João",       "firstName")}
        {field("lastName",  "Sobrenome", "Silva",      "lastName" )}
        {field("telefone",  "Telefone",  "(11) 9 9999-9999", "telefone")}
        {field("cargo",     "Cargo",     "Ex: Técnico de campo", "cargo")}
      </SimpleGrid>

      <Flex justify="flex-end">
        <Button
          leftIcon={<Icon as={MdSave} boxSize="16px" />}
          colorScheme="brand"
          borderRadius="12px"
          h="44px"
          px="24px"
          fontWeight="700"
          isLoading={saving}
          loadingText="Salvando..."
          onClick={onSave}
        >
          Salvar
        </Button>
      </Flex>
    </Card>
  );
}
